import { render, staticRenderFns } from "./ShortcutLoginArea.vue?vue&type=template&id=6a94df50&"
import script from "./ShortcutLoginArea.vue?vue&type=script&lang=ts&"
export * from "./ShortcutLoginArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports